import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { relativeDayLabel } from '../../../../shared/services/sage-integration.model';
import { SageErrorFixStore } from './sage-error-fix.store';
import { SalesGroupItemsComponent } from './sales-group-items.component';

/** "Sales group hasn't come through from Sage": names the groups Sage doesn't know, refreshes them,
 * and offers another group per item for any still missing. */
@Component({
  selector: 'app-refresh-groups-fix',
  standalone: true,
  imports: [CommonModule, SalesGroupItemsComponent],
  templateUrl: './refresh-groups-fix.component.html',
  styleUrls: ['../onboarding-wizard/sage-wizard.shared.css', '../sage-mockup.shared.css', './fix-section.shared.css'],
})
export class RefreshGroupsFixComponent {
  @Input({ required: true }) store!: SageErrorFixStore;
  @Input() syncEnabled = true;
  /** When Aivor last read the groups from Sage. */
  @Input() lastRead: string | null = null;
  @Input() idPrefix = '';

  get names(): string[] {
    return this.store.unsyncedSalesGroups.map((g) => g.description);
  }

  get title(): string {
    const names = this.names;
    if (names.length === 1) return `"${names[0]}" hasn't come through from Sage`;
    if (names.length > 1) return `${names.length} sales groups haven't come through from Sage`;
    return "These items' sales group hasn't come through from Sage";
  }

  get lastReadLabel(): string {
    return relativeDayLabel(this.lastRead);
  }

  /** After a refresh that didn't bring every group in, the items can take another group. */
  get offersAnotherGroup(): boolean {
    return !!this.store.refreshResult && this.names.length > 0 && this.store.salesItems.length > 0 && this.store.usableSalesGroups.length > 0;
  }
}
